import { env } from '@repo/platform-env';

export function getABSmartlyEnvironment() {
  return env.NEXT_PUBLIC_DEPLOYABLE_ENV;
}
